import { useState, useCallback } from 'react';
import { OfficesFilter } from '../models';
import { GlobalButton, SelectInput, TextInput } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import {
  Search as SearchIcon,
  DeleteForever as TrashIcon,
} from '@mui/icons-material';
import { useCitiesOptions } from '../hooks';

interface SearchBarProps {
  initialFilter: OfficesFilter;
  filter: OfficesFilter;
  search: (updatedFilter: OfficesFilter) => void;
}

const SearchBar = ({ initialFilter, filter, search }: SearchBarProps) => {
  const [localFilter, setLocalFilter] = useState<OfficesFilter>(filter);

  const resetFilter = () => {
    setLocalFilter(initialFilter);
    search(initialFilter);
  };

  const handleSearch = () => {
    search(localFilter);
  };

  const handleUpdateFilter = useCallback(
    (updatedFilter: Partial<OfficesFilter>) => {
      setLocalFilter((prev) => ({ ...prev, ...updatedFilter }));
    },
    []
  );

  const { options: cityOptions } = useCitiesOptions();

  return (
    <div className='w-full p-5 flex flex-col justify-center bg-white rounded-sm shadow-xl gap-5'>
      <div style={{ display: 'flex', gap: '10px' }}>
        <TextInput
          name='name-office-search'
          placeholder='Buscar por nombre'
          value={localFilter.name || ''}
          onChange={(value: string | number) =>
            handleUpdateFilter({ name: String(value) })
          }
        />
        <SelectInput
          name='city-office-search'
          placeholder='Seleccione una ciudad'
          value={localFilter.cityId || ''}
          onChange={(value: string) => handleUpdateFilter({ cityId: value })}
          options={cityOptions}
        />
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={resetFilter}
        >
          <TrashIcon color='primary' />
          Limpiar
        </GlobalButton>
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleSearch}
        >
          <SearchIcon color='primary' />
          Buscar
        </GlobalButton>
      </div>
    </div>
  );
};

export default SearchBar;
